// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: user-preference.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { SecurityExpression } from "./security";
import { Watchlist_GroupBy, watchlist_GroupByFromJSON, watchlist_GroupByToJSON } from "./watchlist";

export const protobufPackage = "com.tick2trade.api.userpreference";

export enum DashboardShareStatus {
  NOT_SHARED = 0,
  OWNER = 1,
  VIEWER = 2,
  UNRECOGNIZED = -1,
}

export function dashboardShareStatusFromJSON(object: any): DashboardShareStatus {
  switch (object) {
    case 0:
    case "NOT_SHARED":
      return DashboardShareStatus.NOT_SHARED;
    case 1:
    case "OWNER":
      return DashboardShareStatus.OWNER;
    case 2:
    case "VIEWER":
      return DashboardShareStatus.VIEWER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DashboardShareStatus.UNRECOGNIZED;
  }
}

export function dashboardShareStatusToJSON(object: DashboardShareStatus): string {
  switch (object) {
    case DashboardShareStatus.NOT_SHARED:
      return "NOT_SHARED";
    case DashboardShareStatus.OWNER:
      return "OWNER";
    case DashboardShareStatus.VIEWER:
      return "VIEWER";
    case DashboardShareStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Platform {
  PLATFORM_UNKNOWN = 0,
  DESKTOP = 1,
  MOBILE = 2,
  UNRECOGNIZED = -1,
}

export function platformFromJSON(object: any): Platform {
  switch (object) {
    case 0:
    case "PLATFORM_UNKNOWN":
      return Platform.PLATFORM_UNKNOWN;
    case 1:
    case "DESKTOP":
      return Platform.DESKTOP;
    case 2:
    case "MOBILE":
      return Platform.MOBILE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Platform.UNRECOGNIZED;
  }
}

export function platformToJSON(object: Platform): string {
  switch (object) {
    case Platform.PLATFORM_UNKNOWN:
      return "PLATFORM_UNKNOWN";
    case Platform.DESKTOP:
      return "DESKTOP";
    case Platform.MOBILE:
      return "MOBILE";
    case Platform.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DashboardNamespace {
  NAMESPACE_UNKNOWN = 0,
  CHART = 1,
  SCALPER = 2,
  UNRECOGNIZED = -1,
}

export function dashboardNamespaceFromJSON(object: any): DashboardNamespace {
  switch (object) {
    case 0:
    case "NAMESPACE_UNKNOWN":
      return DashboardNamespace.NAMESPACE_UNKNOWN;
    case 1:
    case "CHART":
      return DashboardNamespace.CHART;
    case 2:
    case "SCALPER":
      return DashboardNamespace.SCALPER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DashboardNamespace.UNRECOGNIZED;
  }
}

export function dashboardNamespaceToJSON(object: DashboardNamespace): string {
  switch (object) {
    case DashboardNamespace.NAMESPACE_UNKNOWN:
      return "NAMESPACE_UNKNOWN";
    case DashboardNamespace.CHART:
      return "CHART";
    case DashboardNamespace.SCALPER:
      return "SCALPER";
    case DashboardNamespace.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface UserSecurityExpressions {
  securityExpressions: SecurityExpression[];
}

export interface UserScreenerLayout {
  id: string;
  name: string;
  layout: string;
  type: UserScreenerLayout_Type;
  category: UserScreenerLayout_Category;
  description: string;
}

export enum UserScreenerLayout_Type {
  USER = 0,
  COMMUNITY = 1,
  /** PROTECTED - community(hidden) */
  PROTECTED = 2,
  UNRECOGNIZED = -1,
}

export function userScreenerLayout_TypeFromJSON(object: any): UserScreenerLayout_Type {
  switch (object) {
    case 0:
    case "USER":
      return UserScreenerLayout_Type.USER;
    case 1:
    case "COMMUNITY":
      return UserScreenerLayout_Type.COMMUNITY;
    case 2:
    case "PROTECTED":
      return UserScreenerLayout_Type.PROTECTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserScreenerLayout_Type.UNRECOGNIZED;
  }
}

export function userScreenerLayout_TypeToJSON(object: UserScreenerLayout_Type): string {
  switch (object) {
    case UserScreenerLayout_Type.USER:
      return "USER";
    case UserScreenerLayout_Type.COMMUNITY:
      return "COMMUNITY";
    case UserScreenerLayout_Type.PROTECTED:
      return "PROTECTED";
    case UserScreenerLayout_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum UserScreenerLayout_Category {
  MY_SCREENER = 0,
  TRENDING = 1,
  MARKET_MOVERS = 2,
  BREAKOUTS = 3,
  MOMENTUM = 4,
  PROTECTED_SCREEN = 5,
  UNRECOGNIZED = -1,
}

export function userScreenerLayout_CategoryFromJSON(object: any): UserScreenerLayout_Category {
  switch (object) {
    case 0:
    case "MY_SCREENER":
      return UserScreenerLayout_Category.MY_SCREENER;
    case 1:
    case "TRENDING":
      return UserScreenerLayout_Category.TRENDING;
    case 2:
    case "MARKET_MOVERS":
      return UserScreenerLayout_Category.MARKET_MOVERS;
    case 3:
    case "BREAKOUTS":
      return UserScreenerLayout_Category.BREAKOUTS;
    case 4:
    case "MOMENTUM":
      return UserScreenerLayout_Category.MOMENTUM;
    case 5:
    case "PROTECTED_SCREEN":
      return UserScreenerLayout_Category.PROTECTED_SCREEN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserScreenerLayout_Category.UNRECOGNIZED;
  }
}

export function userScreenerLayout_CategoryToJSON(object: UserScreenerLayout_Category): string {
  switch (object) {
    case UserScreenerLayout_Category.MY_SCREENER:
      return "MY_SCREENER";
    case UserScreenerLayout_Category.TRENDING:
      return "TRENDING";
    case UserScreenerLayout_Category.MARKET_MOVERS:
      return "MARKET_MOVERS";
    case UserScreenerLayout_Category.BREAKOUTS:
      return "BREAKOUTS";
    case UserScreenerLayout_Category.MOMENTUM:
      return "MOMENTUM";
    case UserScreenerLayout_Category.PROTECTED_SCREEN:
      return "PROTECTED_SCREEN";
    case UserScreenerLayout_Category.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetScreenerWatchlistItemsRequest {
  userScreenerLayout: UserScreenerLayout | undefined;
  groupBy: Watchlist_GroupBy;
}

export interface UserScreenerLayouts {
  userScreenerLayouts: UserScreenerLayout[];
}

export interface UserDeviceProto {
  id: string;
  userId: string;
  platform: UserDeviceProto_Platform;
  deviceManufacturer: string;
  deviceModel: string;
  osVersion: string;
  sdkVersion: string;
  fcmToken: string;
}

export enum UserDeviceProto_Platform {
  PLATFORM_UNKNOWN = 0,
  DESKTOP = 1,
  ANDROID = 2,
  IOS = 3,
  UNRECOGNIZED = -1,
}

export function userDeviceProto_PlatformFromJSON(object: any): UserDeviceProto_Platform {
  switch (object) {
    case 0:
    case "PLATFORM_UNKNOWN":
      return UserDeviceProto_Platform.PLATFORM_UNKNOWN;
    case 1:
    case "DESKTOP":
      return UserDeviceProto_Platform.DESKTOP;
    case 2:
    case "ANDROID":
      return UserDeviceProto_Platform.ANDROID;
    case 3:
    case "IOS":
      return UserDeviceProto_Platform.IOS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserDeviceProto_Platform.UNRECOGNIZED;
  }
}

export function userDeviceProto_PlatformToJSON(object: UserDeviceProto_Platform): string {
  switch (object) {
    case UserDeviceProto_Platform.PLATFORM_UNKNOWN:
      return "PLATFORM_UNKNOWN";
    case UserDeviceProto_Platform.DESKTOP:
      return "DESKTOP";
    case UserDeviceProto_Platform.ANDROID:
      return "ANDROID";
    case UserDeviceProto_Platform.IOS:
      return "IOS";
    case UserDeviceProto_Platform.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AddOrUpdateUserDeviceRequest {
  userDevice: UserDeviceProto | undefined;
}

export interface AddOrUpdateUserDeviceResponse {
  successful: boolean;
}

export interface UserDashboardProto {
  id: string;
  name: string;
  layout: string;
  isPredefined: boolean;
  isDefault: boolean;
  shareState: DashboardShareStatus;
  platform: Platform;
  namespace: DashboardNamespace;
}

export interface UserDashboardsProto {
  userDashboards: UserDashboardProto[];
}

function createBaseUserSecurityExpressions(): UserSecurityExpressions {
  return { securityExpressions: [] };
}

export const UserSecurityExpressions = {
  encode(message: UserSecurityExpressions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.securityExpressions) {
      SecurityExpression.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSecurityExpressions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSecurityExpressions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securityExpressions.push(SecurityExpression.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSecurityExpressions {
    return {
      securityExpressions: globalThis.Array.isArray(object?.securityExpressions)
        ? object.securityExpressions.map((e: any) => SecurityExpression.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserSecurityExpressions): unknown {
    const obj: any = {};
    if (message.securityExpressions?.length) {
      obj.securityExpressions = message.securityExpressions.map((e) => SecurityExpression.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSecurityExpressions>, I>>(base?: I): UserSecurityExpressions {
    return UserSecurityExpressions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSecurityExpressions>, I>>(object: I): UserSecurityExpressions {
    const message = createBaseUserSecurityExpressions();
    message.securityExpressions = object.securityExpressions?.map((e) => SecurityExpression.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUserScreenerLayout(): UserScreenerLayout {
  return { id: "", name: "", layout: "", type: 0, category: 0, description: "" };
}

export const UserScreenerLayout = {
  encode(message: UserScreenerLayout, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.layout !== "") {
      writer.uint32(26).string(message.layout);
    }
    if (message.type !== 0) {
      writer.uint32(40).int32(message.type);
    }
    if (message.category !== 0) {
      writer.uint32(48).int32(message.category);
    }
    if (message.description !== "") {
      writer.uint32(58).string(message.description);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserScreenerLayout {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserScreenerLayout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.layout = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.description = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserScreenerLayout {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      layout: isSet(object.layout) ? globalThis.String(object.layout) : "",
      type: isSet(object.type) ? userScreenerLayout_TypeFromJSON(object.type) : 0,
      category: isSet(object.category) ? userScreenerLayout_CategoryFromJSON(object.category) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: UserScreenerLayout): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.layout !== "") {
      obj.layout = message.layout;
    }
    if (message.type !== 0) {
      obj.type = userScreenerLayout_TypeToJSON(message.type);
    }
    if (message.category !== 0) {
      obj.category = userScreenerLayout_CategoryToJSON(message.category);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserScreenerLayout>, I>>(base?: I): UserScreenerLayout {
    return UserScreenerLayout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserScreenerLayout>, I>>(object: I): UserScreenerLayout {
    const message = createBaseUserScreenerLayout();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.layout = object.layout ?? "";
    message.type = object.type ?? 0;
    message.category = object.category ?? 0;
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseGetScreenerWatchlistItemsRequest(): GetScreenerWatchlistItemsRequest {
  return { userScreenerLayout: undefined, groupBy: 0 };
}

export const GetScreenerWatchlistItemsRequest = {
  encode(message: GetScreenerWatchlistItemsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userScreenerLayout !== undefined) {
      UserScreenerLayout.encode(message.userScreenerLayout, writer.uint32(10).fork()).ldelim();
    }
    if (message.groupBy !== 0) {
      writer.uint32(16).int32(message.groupBy);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetScreenerWatchlistItemsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetScreenerWatchlistItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userScreenerLayout = UserScreenerLayout.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.groupBy = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetScreenerWatchlistItemsRequest {
    return {
      userScreenerLayout: isSet(object.userScreenerLayout)
        ? UserScreenerLayout.fromJSON(object.userScreenerLayout)
        : undefined,
      groupBy: isSet(object.groupBy) ? watchlist_GroupByFromJSON(object.groupBy) : 0,
    };
  },

  toJSON(message: GetScreenerWatchlistItemsRequest): unknown {
    const obj: any = {};
    if (message.userScreenerLayout !== undefined) {
      obj.userScreenerLayout = UserScreenerLayout.toJSON(message.userScreenerLayout);
    }
    if (message.groupBy !== 0) {
      obj.groupBy = watchlist_GroupByToJSON(message.groupBy);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetScreenerWatchlistItemsRequest>, I>>(
    base?: I,
  ): GetScreenerWatchlistItemsRequest {
    return GetScreenerWatchlistItemsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetScreenerWatchlistItemsRequest>, I>>(
    object: I,
  ): GetScreenerWatchlistItemsRequest {
    const message = createBaseGetScreenerWatchlistItemsRequest();
    message.userScreenerLayout = (object.userScreenerLayout !== undefined && object.userScreenerLayout !== null)
      ? UserScreenerLayout.fromPartial(object.userScreenerLayout)
      : undefined;
    message.groupBy = object.groupBy ?? 0;
    return message;
  },
};

function createBaseUserScreenerLayouts(): UserScreenerLayouts {
  return { userScreenerLayouts: [] };
}

export const UserScreenerLayouts = {
  encode(message: UserScreenerLayouts, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.userScreenerLayouts) {
      UserScreenerLayout.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserScreenerLayouts {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserScreenerLayouts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userScreenerLayouts.push(UserScreenerLayout.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserScreenerLayouts {
    return {
      userScreenerLayouts: globalThis.Array.isArray(object?.userScreenerLayouts)
        ? object.userScreenerLayouts.map((e: any) => UserScreenerLayout.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserScreenerLayouts): unknown {
    const obj: any = {};
    if (message.userScreenerLayouts?.length) {
      obj.userScreenerLayouts = message.userScreenerLayouts.map((e) => UserScreenerLayout.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserScreenerLayouts>, I>>(base?: I): UserScreenerLayouts {
    return UserScreenerLayouts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserScreenerLayouts>, I>>(object: I): UserScreenerLayouts {
    const message = createBaseUserScreenerLayouts();
    message.userScreenerLayouts = object.userScreenerLayouts?.map((e) => UserScreenerLayout.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUserDeviceProto(): UserDeviceProto {
  return {
    id: "",
    userId: "",
    platform: 0,
    deviceManufacturer: "",
    deviceModel: "",
    osVersion: "",
    sdkVersion: "",
    fcmToken: "",
  };
}

export const UserDeviceProto = {
  encode(message: UserDeviceProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.platform !== 0) {
      writer.uint32(24).int32(message.platform);
    }
    if (message.deviceManufacturer !== "") {
      writer.uint32(34).string(message.deviceManufacturer);
    }
    if (message.deviceModel !== "") {
      writer.uint32(42).string(message.deviceModel);
    }
    if (message.osVersion !== "") {
      writer.uint32(50).string(message.osVersion);
    }
    if (message.sdkVersion !== "") {
      writer.uint32(58).string(message.sdkVersion);
    }
    if (message.fcmToken !== "") {
      writer.uint32(66).string(message.fcmToken);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserDeviceProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserDeviceProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.platform = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.deviceManufacturer = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.deviceModel = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.osVersion = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.sdkVersion = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.fcmToken = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserDeviceProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      platform: isSet(object.platform) ? userDeviceProto_PlatformFromJSON(object.platform) : 0,
      deviceManufacturer: isSet(object.deviceManufacturer) ? globalThis.String(object.deviceManufacturer) : "",
      deviceModel: isSet(object.deviceModel) ? globalThis.String(object.deviceModel) : "",
      osVersion: isSet(object.osVersion) ? globalThis.String(object.osVersion) : "",
      sdkVersion: isSet(object.sdkVersion) ? globalThis.String(object.sdkVersion) : "",
      fcmToken: isSet(object.fcmToken) ? globalThis.String(object.fcmToken) : "",
    };
  },

  toJSON(message: UserDeviceProto): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.platform !== 0) {
      obj.platform = userDeviceProto_PlatformToJSON(message.platform);
    }
    if (message.deviceManufacturer !== "") {
      obj.deviceManufacturer = message.deviceManufacturer;
    }
    if (message.deviceModel !== "") {
      obj.deviceModel = message.deviceModel;
    }
    if (message.osVersion !== "") {
      obj.osVersion = message.osVersion;
    }
    if (message.sdkVersion !== "") {
      obj.sdkVersion = message.sdkVersion;
    }
    if (message.fcmToken !== "") {
      obj.fcmToken = message.fcmToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserDeviceProto>, I>>(base?: I): UserDeviceProto {
    return UserDeviceProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserDeviceProto>, I>>(object: I): UserDeviceProto {
    const message = createBaseUserDeviceProto();
    message.id = object.id ?? "";
    message.userId = object.userId ?? "";
    message.platform = object.platform ?? 0;
    message.deviceManufacturer = object.deviceManufacturer ?? "";
    message.deviceModel = object.deviceModel ?? "";
    message.osVersion = object.osVersion ?? "";
    message.sdkVersion = object.sdkVersion ?? "";
    message.fcmToken = object.fcmToken ?? "";
    return message;
  },
};

function createBaseAddOrUpdateUserDeviceRequest(): AddOrUpdateUserDeviceRequest {
  return { userDevice: undefined };
}

export const AddOrUpdateUserDeviceRequest = {
  encode(message: AddOrUpdateUserDeviceRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userDevice !== undefined) {
      UserDeviceProto.encode(message.userDevice, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddOrUpdateUserDeviceRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddOrUpdateUserDeviceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userDevice = UserDeviceProto.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddOrUpdateUserDeviceRequest {
    return { userDevice: isSet(object.userDevice) ? UserDeviceProto.fromJSON(object.userDevice) : undefined };
  },

  toJSON(message: AddOrUpdateUserDeviceRequest): unknown {
    const obj: any = {};
    if (message.userDevice !== undefined) {
      obj.userDevice = UserDeviceProto.toJSON(message.userDevice);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddOrUpdateUserDeviceRequest>, I>>(base?: I): AddOrUpdateUserDeviceRequest {
    return AddOrUpdateUserDeviceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddOrUpdateUserDeviceRequest>, I>>(object: I): AddOrUpdateUserDeviceRequest {
    const message = createBaseAddOrUpdateUserDeviceRequest();
    message.userDevice = (object.userDevice !== undefined && object.userDevice !== null)
      ? UserDeviceProto.fromPartial(object.userDevice)
      : undefined;
    return message;
  },
};

function createBaseAddOrUpdateUserDeviceResponse(): AddOrUpdateUserDeviceResponse {
  return { successful: false };
}

export const AddOrUpdateUserDeviceResponse = {
  encode(message: AddOrUpdateUserDeviceResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.successful !== false) {
      writer.uint32(8).bool(message.successful);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddOrUpdateUserDeviceResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddOrUpdateUserDeviceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.successful = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddOrUpdateUserDeviceResponse {
    return { successful: isSet(object.successful) ? globalThis.Boolean(object.successful) : false };
  },

  toJSON(message: AddOrUpdateUserDeviceResponse): unknown {
    const obj: any = {};
    if (message.successful !== false) {
      obj.successful = message.successful;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddOrUpdateUserDeviceResponse>, I>>(base?: I): AddOrUpdateUserDeviceResponse {
    return AddOrUpdateUserDeviceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddOrUpdateUserDeviceResponse>, I>>(
    object: I,
  ): AddOrUpdateUserDeviceResponse {
    const message = createBaseAddOrUpdateUserDeviceResponse();
    message.successful = object.successful ?? false;
    return message;
  },
};

function createBaseUserDashboardProto(): UserDashboardProto {
  return {
    id: "",
    name: "",
    layout: "",
    isPredefined: false,
    isDefault: false,
    shareState: 0,
    platform: 0,
    namespace: 0,
  };
}

export const UserDashboardProto = {
  encode(message: UserDashboardProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.layout !== "") {
      writer.uint32(26).string(message.layout);
    }
    if (message.isPredefined !== false) {
      writer.uint32(32).bool(message.isPredefined);
    }
    if (message.isDefault !== false) {
      writer.uint32(40).bool(message.isDefault);
    }
    if (message.shareState !== 0) {
      writer.uint32(48).int32(message.shareState);
    }
    if (message.platform !== 0) {
      writer.uint32(56).int32(message.platform);
    }
    if (message.namespace !== 0) {
      writer.uint32(64).int32(message.namespace);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserDashboardProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserDashboardProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.layout = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isPredefined = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.shareState = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.platform = reader.int32() as any;
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.namespace = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserDashboardProto {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      layout: isSet(object.layout) ? globalThis.String(object.layout) : "",
      isPredefined: isSet(object.isPredefined) ? globalThis.Boolean(object.isPredefined) : false,
      isDefault: isSet(object.isDefault) ? globalThis.Boolean(object.isDefault) : false,
      shareState: isSet(object.shareState) ? dashboardShareStatusFromJSON(object.shareState) : 0,
      platform: isSet(object.platform) ? platformFromJSON(object.platform) : 0,
      namespace: isSet(object.namespace) ? dashboardNamespaceFromJSON(object.namespace) : 0,
    };
  },

  toJSON(message: UserDashboardProto): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.layout !== "") {
      obj.layout = message.layout;
    }
    if (message.isPredefined !== false) {
      obj.isPredefined = message.isPredefined;
    }
    if (message.isDefault !== false) {
      obj.isDefault = message.isDefault;
    }
    if (message.shareState !== 0) {
      obj.shareState = dashboardShareStatusToJSON(message.shareState);
    }
    if (message.platform !== 0) {
      obj.platform = platformToJSON(message.platform);
    }
    if (message.namespace !== 0) {
      obj.namespace = dashboardNamespaceToJSON(message.namespace);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserDashboardProto>, I>>(base?: I): UserDashboardProto {
    return UserDashboardProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserDashboardProto>, I>>(object: I): UserDashboardProto {
    const message = createBaseUserDashboardProto();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.layout = object.layout ?? "";
    message.isPredefined = object.isPredefined ?? false;
    message.isDefault = object.isDefault ?? false;
    message.shareState = object.shareState ?? 0;
    message.platform = object.platform ?? 0;
    message.namespace = object.namespace ?? 0;
    return message;
  },
};

function createBaseUserDashboardsProto(): UserDashboardsProto {
  return { userDashboards: [] };
}

export const UserDashboardsProto = {
  encode(message: UserDashboardsProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.userDashboards) {
      UserDashboardProto.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserDashboardsProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserDashboardsProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userDashboards.push(UserDashboardProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserDashboardsProto {
    return {
      userDashboards: globalThis.Array.isArray(object?.userDashboards)
        ? object.userDashboards.map((e: any) => UserDashboardProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UserDashboardsProto): unknown {
    const obj: any = {};
    if (message.userDashboards?.length) {
      obj.userDashboards = message.userDashboards.map((e) => UserDashboardProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserDashboardsProto>, I>>(base?: I): UserDashboardsProto {
    return UserDashboardsProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserDashboardsProto>, I>>(object: I): UserDashboardsProto {
    const message = createBaseUserDashboardsProto();
    message.userDashboards = object.userDashboards?.map((e) => UserDashboardProto.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
